import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faFolderOpen } from '@fortawesome/pro-solid-svg-icons';

class Group extends React.Component {
  static propTypes = {
    group: PropTypes.shape({
      memberCount: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    selected: PropTypes.bool,
    onDeselect: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  }

  handleClick = () => {
    if (this.props.selected) {
      this.props.onDeselect(this.props.group);
    } else {
      this.props.onSelect(this.props.group);
    }
  }

  render() {
    const badgeClassName = classNames('badge ml-2 pull-right', {
      'group-number-pill': !this.props.selected,
      'group-number-pill-active': this.props.selected,
    });

    return (
      <div className="clickable mb-2" onClick={this.handleClick}>
        <FontAwesomeIcon
          className="right-buffer-md folder-icon"
          icon={this.props.selected ? faFolderOpen : faFolder}
        />

        <span className="group-text">
          {this.props.group.name}
        </span>

        <span className={badgeClassName}>
          {this.props.group.memberCount}
        </span>
      </div>
    );
  }
}

export default Group;
